(function($) {

    // functions 

    function setCookie(key, value) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }

    function adjustHeaderspacerHeight(){
        if($('#alert').length === 0 || $('#alert').hasClass('disabled')){
            var headerHeight = $('#headerspacer').height();
            var menuTop = $('#mobile-menu').css('top');
            var newHeight = headerHeight - 50;
            var newTop = parseInt(menuTop) - 50;
            $('#headerspacer').height(newHeight);
            $('#mobile-menu').css({
                'top' : newTop + 'px',
                height: 'calc(100vh - ' + newTop + 'px )',
            });
        }
    }


    $(document).ready(function(){

        // document ready

        $('#alert').find('.alert-close').on('click' , function(e){
            e.preventDefault();
            e.stopPropagation();
            $('#alert').slideUp('fast').addClass('disabled');
            setCookie('alertbar' , 'false');
            adjustHeaderspacerHeight();
        });

        adjustHeaderspacerHeight();

    });
    
    
    })(jQuery);